import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { useTranslation } from "react-i18next";
import { useThemeContext } from "../../../contexts/ThemeContext";

/**
 * Dark/Light mode buttons — exact copy of the ACT SI Console's
 * DarkModeButtons component (colors, sizing, behavior). Persistence is
 * handled by the ThemeContext via the shared `darkMode` cookie.
 */
function DarkModeButtons() {
  const { darkMode, setDarkMode } = useThemeContext();
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        minWidth: "18rem",
        height: "2.875rem",
        gap: "0.5rem",
      }}
    >
      <Button
        sx={{
          flex: 1,
          fontSize: "1rem",
          backgroundColor: darkMode ? "#2a2a2a" : "#404040",
          borderRadius: "0.25rem",
          color: darkMode ? "#5b5b5b" : "#ffffff",
          textTransform: "capitalize",
        }}
        onClick={() => setDarkMode(true)}
      >
        {t("Dark")}
      </Button>

      <Button
        sx={{
          flex: 1,
          fontSize: "1rem",
          backgroundColor: darkMode ? "#eeeeee" : "#aaaaaa",
          borderRadius: "0.25rem",
          color: darkMode ? "#121212" : "#eeeeee",
          textTransform: "capitalize",
        }}
        onClick={() => setDarkMode(false)}
      >
        {t("Light")}
      </Button>
    </Box>
  );
}

export default DarkModeButtons;
